/**
 * @return {{click: string}}
 */
export const lumnizLanding = () => ({
  click: 'en_savoir_plus_gamification',
});
